import React, { useCallback } from "react";
import queryString from 'query-string';
import { message } from 'antd';
import { feiShuCodeApi, code2TokenApi, pageDetailApi } from '../../action';
import { AUTH_TOKEN_NAME } from '../../const';
import useEffectOnce from '../../utils/useEffectOnce';
import redirectUrl from "../../utils/redirectUrl";
import syncSubIframe from "../../utils/syncSubIframe";
import SsoUploadTrack from "../../utils/ssoUploadTrack";
import OtherLogin from "../login/otherLogin";
import { Spin } from 'antd';

interface LoginUrlParams {
    id?: string;
    code?: string;
    target?: string;
    state?: string;
    USER_TYPE?: string;
    sp?: string;
    [key: string]: any;
}

const FeiShuCodeCallback = () => {
    const params: LoginUrlParams = queryString.parse(window.location.search.split('?')[1] || '');

    useEffectOnce(() => {
        if (params.code) {
            handlePostMessage('get_feishu_code', params.code);
        }
    });

    const handlePostMessage = useCallback((event: string, code: string) => {
        console.log('handlePostMessage', event, code);
        if (window.opener) {
            let baseURL = 'http://localhost:3333/';
            if (/sso-tst.shizhi-inc.com/.test(window.location.host)) {
                baseURL = 'https://modelx-tst.shizhi-inc.com/';
            }
            if (/sso-stg.shizhi-inc.com/.test(window.location.host)) {
                baseURL = 'https://modelx-stg.shizhi-inc.com/';
            }
            if (/sso.shizhi-inc.com/.test(window.location.host)) {
                baseURL = 'https://modelx.shizhi-inc.com/';
            }
            window.opener.postMessage({
                from: 'ssoLogin',
                event,
                code
            }, baseURL);
            window.close();
        }
        else {
            console.log('window.opener is not found');
        }
    }, []);

    return <Spin size="large" style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
};

export default FeiShuCodeCallback;